// Default System → Sub-system taxonomy loaders for the SubSystemPicker
// ("Pick a category" step of the field-added variant flow).
//
// PowerSync builds run fully offline, where GET /asset-systems and
// GET /asset-systems/:id/sub-systems are unreachable. When the
// PowerSync capture adapter is active these route to the local SQLite
// mirror; otherwise they hit the REST endpoints. Both paths honour the
// same response contract (an array of rows) so the picker consumes
// whichever the build selects without branching.
//
// Lives outside the picker component so the routing decision is unit
// testable without rendering React — mirrors default-asset-type-search.ts,
// which does the same for the dialog's search step.

import {
  loadSubSystemsLocal,
  loadSystemsLocal,
} from '../../hooks/powersync/load-classification-tree-local'
import {
  fetchSubSystems,
  fetchSystems,
  type AssetSubSystemListRow,
  type AssetSystemListRow,
} from '../../hooks/use-classification'
import { POWERSYNC_CAPTURE_CLIENT_ENABLED } from '../client/capture-client-factory'

export function defaultLoadSystems(init: {
  signal: AbortSignal
}): Promise<AssetSystemListRow[]> {
  if (POWERSYNC_CAPTURE_CLIENT_ENABLED) {
    return loadSystemsLocal(init)
  }
  return fetchSystems(init).then((res) => res.systems)
}

export function defaultLoadSubSystems(
  systemId: string,
  init: { signal: AbortSignal },
): Promise<AssetSubSystemListRow[]> {
  if (POWERSYNC_CAPTURE_CLIENT_ENABLED) {
    return loadSubSystemsLocal(systemId, init)
  }
  return fetchSubSystems(systemId, init).then((res) => res.subSystems)
}
